export const validateAchAuthorization = (
  achAuthorization: boolean,
) => {
  if (!achAuthorization) {
    return `You must agree to the ACH authorization agreement.`;
  }
  return null;
};
